import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Main from './Main';
import vitals from './vitals';

// ResizeObserver polyfill to fix "ResizeObserver loop limit exceeded" error
if (typeof window !== 'undefined') {
  // Save the original error handler
  const originalOnError = window.onerror;
  
  // Create a custom error handler to suppress ResizeObserver errors
  window.onerror = function(msg, url, line, column, error) {
    // Check if the error is specifically the ResizeObserver loop limit exceeded error
    if (
      (typeof msg === 'string' && msg.includes('ResizeObserver loop limit exceeded')) || 
      (error && error.message && error.message.includes('ResizeObserver loop limit exceeded'))
    ) {
      // Completely suppress this specific error - it's a known Chrome issue
      return true; // Prevent the error from propagating
    }
    
    // Handle other ResizeObserver errors but log more details
    if (
      (typeof msg === 'string' && msg.includes('ResizeObserver')) || 
      (error && error.message && error.message.includes('ResizeObserver'))
    ) {
      return true; // Prevent the error from propagating
    }
    
    // For other errors, use the original handler if available
    if (originalOnError) {
      return originalOnError(msg, url, line, column, error);
    }
    
    return false; // Let other errors propagate as usual
  };
  
  // Also patch the ResizeObserver prototype to add a more robust error handler
  // This helps prevent errors during rapid resizing or navigation
  try {
    const originalObserve = ResizeObserver.prototype.observe;
    ResizeObserver.prototype.observe = function(target, options) {
      if (target && target.nodeType === 1) { // Element node
        try {
          return originalObserve.call(this, target, options);
        } catch (e) {
          // Silently fail instead of crashing
        }
      }
    };
    
    const originalUnobserve = ResizeObserver.prototype.unobserve;
    ResizeObserver.prototype.unobserve = function(target) {
      if (target && target.nodeType === 1) { // Element node
        try {
          return originalUnobserve.call(this, target);
        } catch (e) {
          // Silently fail instead of crashing
        }
      }
    };
  } catch (e) {
    // Ignore errors related to patching
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

vitals(); 